import { Component, Input, OnInit } from '@angular/core';
import { getPrettyPropertyRecordCalculationStatus } from 'src/app/shared/enums/property-record-calculation-status-enum';
import * as _ from 'lodash';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-process-stats-by-status-section',
    templateUrl: './process-stats-by-status-section.component.html',
    styleUrls: ['./process-stats-by-status-section.component.scss']
})
export class ProcessStatsByStatusSectionComponent implements OnInit {
    @Input()
    process: ITaskModel;

    @Input()
    smallTitle: boolean;

    @Input()
    hideTitle: boolean;

    @Input()
    showRatio: boolean;

    @Input()
    showTotal: boolean;

    constructor() {}

    ngOnInit(): void {}

    statusFormatter(calculationStatusCode: number): string {
        return getPrettyPropertyRecordCalculationStatus(calculationStatusCode);
    }

    summaryStatistic({ statsByStatus, zoningCodeRecords }) {
        const me = this;
        return statsByStatus.reduce(
            function(accumulator, statistic) {
                return {
                    count: accumulator.count + statistic.count,
                    ratio: Number(
                        (
                            accumulator.ratio +
                            (_.isFinite(statistic.ratio)
                                ? statistic.ratio
                                : me.getRatio(statistic.count, zoningCodeRecords))
                        ).toFixed(2)
                    )
                };
            },
            { count: 0, ratio: 0 }
        );
    }

    getRatio(count: number, total: number): number {
        return total > 0 ? Number(((count * 100) / total).toFixed(2)) : 0;
    }
}
